export default __webpack_public_path__ + "static/media/bmj.965eb80a.png";